import { render, staticRenderFns } from "./addChuKuPlan.vue?vue&type=template&id=65775eaf&"
import script from "./addChuKuPlan.vue?vue&type=script&lang=js&"
export * from "./addChuKuPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports